import React from 'react'

import Header from '../header/Header';
import WhyUs from '../whyus/WhyUs';
import Products from '../products/Products';
import Nav from '../nav/Nav';
import Services from '../services/Services';
import Expertise from '../experties/Expertise';
import Technologies from '../technologies/Technologies';


const Home = () => {
  return (
    <>
      <Nav theme="LIGHT"/>
      <Header />
      <WhyUs />
      <br/>
      <br/>
      <Services />
      <Expertise />
      <Products />
      <Technologies />
    </>
  )
}

export default Home